import { apiTimeOut } from "./constant";
export let category;
export const limitApiCall = (callback) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      callback.apply(context, args);
    }, apiTimeOut);
  };
};
export const setAvailableCategory = (key) => {
  category = key;
};

export const getLocalStorage = (key) => localStorage.getItem(key);

export const clearAllLocalStorage = () => localStorage.clear();

export const formatDate = (date) => {
  if (!date) {
    return "NA";
  }
  const mainDate = new Date(date);

  // Get day, month, and year
  const day = mainDate.getDate().toString().padStart(2, "0");
  const month = mainDate
    .toLocaleString("en-US", { month: "short" })
    .toUpperCase();
  const year = mainDate.getFullYear();

  // Format as DD-MMM-YYYY
  const formattedDate = `${day}-${month}-${year}`;
  return formattedDate;
};

export const formatDateTime = (date) => {
  if (!date) {
    return "NA";
  }

  // Function to get the current date and time in IST
  function getISTDate() {
    const mainDate = new Date(date);

    // IST offset is UTC + 5:30
    const offsetIST = 5.5 * 60; // Offset in minutes
    const localOffset = mainDate.getTimezoneOffset(); // Local offset in minutes
    const ISTTime = new Date(
      mainDate.getTime() + (offsetIST + localOffset) * 60000
    );

    return ISTTime;
  }

  // Options for date formatting
  const options = {
    weekday: "short", // long or short
    year: "2-digit", // numeric or 2-digit
    month: "short", // long, short, or numeric
    day: "2-digit", // numeric or 2-digit
    hour: "2-digit", // numeric or 2-digit
    minute: "2-digit", // numeric or 2-digit
    hour12: true, // 12-hour format
  };

  // Get the IST date
  const istDate = getISTDate();

  // Format the date
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
    istDate
  );
  return formattedDate;
};
